module.exports = __webpack_public_path__ + "img/julho.6cd9cc22.png";